import {useEffect} from 'react';
import { Icon } from '@iconify/react';
import TableGrid from '../StockItems/TableGrid';
import NormalBtn from '../StockItems/NormalBtn';
import DoGuide from './DoGuide';
import UpperPointer from './UpperPointer';
import EditBarTitleFull from './EditBarTitleFull';
import * as CoreFns from '../utilities/CoreFns';
import * as SharedAcross from '../utilities/SharedAcross';
import * as BaseItems from '../utilities/BaseItems';

function App(props) {

  var addWhereText = props.addWhereText;
  var currentList = props.currentList;
  var addPath = props.addPath;
  var setAddWhichItem = props.setAddWhichItem;
  var addWhichItem = props.addWhichItem;
  var highlightAnItem = props.highlightAnItem;
  var logInState = props.logInState;
  var addItem = props.addItem;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var addPanel = props.addPanel;
  var organicChanges = props.organicChanges;
  var setItemEdited = props.setItemEdited;
  var addToExtraScreen = props.addToExtraScreen;
  var addLoc = props.addLoc;
  var setAddLoc = props.setAddLoc;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var error = props.error;
  var itemEdited = props.itemEdited;
  // var isFEOrPUShown = props.isFEOrPUShown;
  // var whichFEOrPUShown = props.whichFEOrPUShown;


  var addNext = props.addNext;
  var thisItem = props.thisItem;
  var addFE = props.addFE;




  useEffect(()=>{
    setAddLoc(0);
  }, [addWhereText]); 
//

  if (!thisItem){

  //
   return <div className='container' ><center><br/><DoGuide addToExtraScreen={addToExtraScreen} set={{t:'tabPages'}} /><br/><NormalBtn icon='carbon:add' title='Page' backScreen={true} onClick={addFE('fe')}/><br/>
    <br/><NormalBtn icon='carbon:add' title='Pop-Up' backScreen={true} onClick={addFE('pu')}/>

   </center></div>
  }
//

  var gotNavBar = false;
  var navBarPath = [];

  if (itemEdited.path[0] === 'fo'){
  }else{
    if (itemEdited.t === 'asset'){
      navBarPath = [itemEdited.screenPath[0], itemEdited.screenPath[1], 'nv'];
    }else{
      navBarPath = [itemEdited.path[0], itemEdited.path[1], 'nv'];
    }
    var currentNavBar = CoreFns.goDownPath(currentList, navBarPath);
    if (currentNavBar.on){
        gotNavBar = true;
      if (currentNavBar.on === 1){
      }else{
        navBarPath = ['cn', currentNavBar.on, 'nv'];
        try{
          currentNavBar = CoreFns.goDownPath(currentList, navBarPath);
        }catch(err){
          gotNavBar = false;
        }
      }
    }

  }

  var toAdd = [];
  if (addWhereText === 'navBar' || addWhereText === 'navDropDown'){
    toAdd = ['BUTTON', 'IMG', 'navLink', 'navBrand', 'navDropDown'];
  }else if (addWhereText === 'SUMMARY'){
    toAdd = ['SUMMARYDIV'];
  }else if (addWhereText === 'CONTAINER'){
    toAdd = ['HFLEX'];
  }else if (addWhereText === 'Page'){
    if (gotNavBar){
    }else{
      toAdd.push('navBar');
    }
    toAdd.push('PANEL');
    if (currentList.fo && currentList.fo.on){
    }else{
      toAdd.push('FOOTER');
    }
  }else if (addWhereText === 'TABLE'){
    toAdd = ['TR'];
  }else if (addWhereText === 'TR'){
    toAdd = ['TD'];
  }else if (addWhereText === 'TABS'){
    toAdd = ['TABITEM'];
  }else if (addWhereText === 'PANEL' && addLoc === 0){
    toAdd = ['CONTAINER', 'ALERT'];
  }else{
    toAdd = ['DIV', 'BUTTON', 'IMG', 'INPUT', 'CARD', 'CONTAINER', 'SUMMARY', 'TIMER', 'VIDEO', 'TABLE', 'LINECHART', 'TABS', 'GALLERY', 'ICON'];

    if (CoreFns.isAdmin(logInState)){
      toAdd.push('BARCHART')
      toAdd.push('PIECHART');
    }

    if (addWhereText === 'HFLEX'){
      toAdd.push('SPACE');
    }

    if (addWhereText === 'Panel'){
      addPath[4] = 'i';
    }
  }

  function addSomething(itemT, addPath){
    return function(e){
      setAddWhichItem(false);

      var position = false;
      if (addLoc){
        position = {left:5, top:5};
      }
      
      function doAddItem(item){
        addItem(item, addPath, position);
      }
      var item = {}
      var changes = [];

      if (e){
        e.stopPropagation();
      }

      if (itemT === 'PANEL'){
        addPanel(itemEdited.path[0], itemEdited.path[1])(e);
      }else if (itemT === 'FOOTER'){
        if (currentList.fo){
          var reuse = window.confirm('Would you like to reuse your previous footer design?');
          if (reuse){
            changes = [{t:'w',w:['fo','on'],n:1}];
            organicChanges(changes);
            setItemEdited({t:'screen', path:['fo']});
            return;
          }
        }
        addToExtraScreen({t:'categorySelector', itemT:'FOOTER', position, insetWidth, insetHeight, addPath:[]});
      }else if (itemT === 'navBar'){
        addToExtraScreen({t:'categorySelector', itemT:'navBar', position, insetWidth, insetHeight, addPath:navBarPath});
      }else if (itemT === 'BUTTON' || itemT === 'INPUT' || itemT === 'VIDEO' || itemT === 'TIMER' || itemT === 'LINECHART' || itemT === 'BARCHART' || itemT === 'PIECHART' || itemT === 'CONTAINER' || itemT === 'HFLEX' || itemT === 'GALLERY' || itemT === 'SUMMARY' || itemT === 'TABS' || itemT === 'TABLE' || itemT === 'CARD' || itemT === 'DIV'){
        addToExtraScreen({t:'categorySelector', itemT, position, insetWidth, insetHeight, addPath});
      }else if (itemT === 'IMG'){
        addToExtraScreen({t:'srcSelector', isNew:{addWhereText, position, insetWidth, insetHeight}, path:addPath});
      }else if (itemT === 'ALERT'){
        var alertPath = [itemEdited.path[0], itemEdited.path[1], '_s', addPath[3], 'al']
        addToExtraScreen({t:'categorySelector', itemT, position, insetWidth, insetHeight, addPath:alertPath});
      }else{
        if (itemT === 'TR' || itemT === 'TD'){
          item = {t:itemT, oc:{}, s:{}, i:{}};
        }else if (itemT === 'ICON'){
          item = BaseItems.icon();
        }else if (itemT === 'SPACE'){
          var p = window.prompt('Number of column spaces (1-12)', 3);
          if (p){
            if (SharedAcross.isIntegerText(p)){
              if (p >= 1 && p <= 12){
                item = {t:'SPACE', s:{colWidth:{t:'bsu',v:+p}}, oc:{}, i:{}};
                doAddItem(item);          
                return;
              }
            } 
            window.alert('Integer between 1 to 12 required');
            return;
          }
        }else if (itemT === 'navLink'){
          item = {t:'navLink', s:{text:{t:'raw',v:'Link'}}, oc:{click:{t: "openUrl", url:{o: {t: 's', v: 'https://www.google.com'}, r: {t: 'Text String'}, t: "formula", x: [{t: 's', v: 'https://www.google.com'}], y: {}}}}};
        }else if (itemT === 'navDropDown'){
          item = {t:'navDropDown', s:{text:{t:'raw',v:'Dropdown Menu'}}, oc:{}, i:{}};
        }else if (itemT === 'navBrand'){
          item = BaseItems.navBarItemBaseline();
        }else if (itemT === 'SUMMARYDIV'){
          item = {t:'SUMMARYDIV', s:{text:{t:'raw', v:'Title'}, textAlignment:{t:'raw', v:'text-left'}}, x:[{t:'br'}], oc:{}};
        }else if (itemT === 'TABITEM'){
          item = {t:'TABITEM', s:{text:{t:'raw',v:'Tab Label'}}, oc:{}, i:{}};
        }else{
          console.warn(itemT);
          return;
        }
        doAddItem(item);
      }
    }
  }  



  var parseItemsToAdd = toAdd.map((anItem, index)=>{
    var x = CoreFns.getElementInfo(anItem);
    x.o = anItem;
    return x;
  })


  function onMouseEnter(tgt, path){
    return function(e){
      setAddWhichItem({t:tgt, p:path});
    }
  }

  function onMouseOut(e){
    setAddWhichItem(false);
  }

  function showElements(items, addPathHere){

     var grid = SharedAcross.convertToGrid(items, 3, false);
     return grid.map((aGrid, indexX)=>{
      var inside = aGrid.map((anItem, index)=>{
        if (anItem){
          var classButton = 'btn epillchoice';
          
          if (index !== 0){
            classButton += ' removeLeftBorder';
          }
          if (+indexX > 0){
            classButton += ' removeTopBorder';
          }
          if (addWhichItem && addWhichItem.t === anItem.t && addPathHere.join(' ') === addWhichItem.p.join(' ')){
            classButton += ' epillchoiceSelected';
          }

          var colorStyle = {};
          if (highlightAnItem && highlightAnItem.t === 'addElement' && highlightAnItem.v === anItem.t){
            colorStyle.color = 'blue';
            colorStyle.fontWeight = 'bold';
          }

          return <div className='elementsqtip tip-bottom noFiringInside' data-tip={anItem.h} onClick={addSomething(anItem.o, addPathHere)} onMouseEnter={onMouseEnter(anItem.o, addPathHere)} onMouseOut={onMouseOut}><div className={classButton} style={colorStyle} ><div ><Icon width = '20' icon={anItem.i} /></div>
            <div style={colorStyle}>{anItem.t}</div></div></div>
        }else{
          return null;
        }
      })

      return <div key={indexX} className='btn-group'>{inside}</div>
     })
  };
//

  var partPieces = [];
  if (addWhereText === 'navBar' && currentNavBar.s.navbarCluster){
    var parts1 = [{t:'Left Cluster', addPath:navBarPath.concat(['i'])}, {t:'Center Cluster', addPath:navBarPath.concat(['ic'])},{t:'Right Cluster', addPath:navBarPath.concat(['ir'])}]

    partPieces = parts1.map((aPart, index)=>{
      var designListOut = showElements(parseItemsToAdd, aPart.addPath);
      return (<div><br/>
          {aPart.t}<br/>
            {designListOut}
          </div>)

    })

//    
  }else{
    var parts = [{t:'Layout', n:'l'}, {t:'Design', n:'d'}, {t:'Components', n:'c'}, {t:'Charts', n:'ch'}];
    partPieces = parts.map((aPart, index)=>{

      var designList = parseItemsToAdd.filter((aP, index2)=>{
        return aP.n === aPart.n;
      });

      if (designList.length === 0){
        return null;
      }else{
        var designListOut = showElements(designList, addPath);
        return (<div><br/>
            {aPart.t}<br/>
            
              {designListOut}
            </div>)

      }

    })

  }
//

    var addFormPieceBreak = null;
    var addFormPiece = null;
    if (addWhereText === 'PANEL'){
      addFormPieceBreak = <br/>
      function clickAddLoc(x){
        setAddLoc(x.i);
      }
      var options = [{i:0, t:'Responsive', ic:'ri:side-bar-fill'}, {i:1, t:'Fixed', ic:'ic:baseline-gps-fixed'}];
      addFormPiece = <TableGrid options={options} currentAnswer={addLoc} onClick={clickAddLoc} />
    }

    var preText = 'Add Items to ';
    if (addNext){
      preText = 'Add Item next to ';
    }

//
    return <div className='container' style={{textAlign:'left'}}><br/>
            <div className='container'><div className='row'>
              <UpperPointer currentList={currentList} error={error} itemEdited={itemEdited} setItemEdited={setItemEdited} highlightAnItem={highlightAnItem} isShowingSomeDropDown={isShowingSomeDropDown} whereFrom='add'/>
              <div className='col-6'><DoGuide addToExtraScreen={addToExtraScreen} set={{t:'tabElements', addWhereText, addLoc}} /></div>
              </div></div>
              <EditBarTitleFull currentList={currentList} itemEdited={itemEdited} organicChanges={organicChanges} preText={preText}/>
              {addFormPieceBreak}
              {addFormPiece}
              {partPieces}
      </div>
//  
}

export default App;
